import * as React from 'react'

import { ARow, ACol } from '../components/atoms/index'
import { RouteComponentProps } from 'react-router'
import Reset from '../containers/auth/Reset'

class PReset extends React.Component<RouteComponentProps<{ token: string }>> {
    onSuccess = () => {
        this.props.history.push('/customer/dashboard')
    }

    render() {
        const { token } = this.props.match.params

        const decodedToken = decodeURIComponent(token)

        return (
            <ARow>
                <ACol md={{ size: 4, offset: 4 }}>
                    <Reset token={decodedToken} onSuccess={this.onSuccess} />
                </ACol>
            </ARow>
        )
    }
}

export default PReset
